import { FactoryContext } from '@sqior/react/factory';
import ConfirmIdentityPage from './confirm-identity-page/confirm-identity-page';

export function UIAuthPlugin(context: FactoryContext) {
  context.factory.add('ConfirmIdentityPage', ConfirmIdentityPage);
}
